// 请求接口封装
import axios from 'axios'

async function getToken() {
    var res = await axios.get(`${projectConfig.LOGIN_HEADER}/getJwt`);
    if (res.status === 200 && res.data.errcode == 0) {
        let time = new Date(new Date().getTime() + 1000 * (res.data.data.expires_in-30));
        var timestamp = Date.parse(time);
        localStorage.setItem("_t", res.data.data.token);
        localStorage.setItem("_tt", timestamp);
        return res.data.data.token
    }
}

export function request(config) {
    const instance = axios.create({
        // baseURL: process.env.VUE_APP_BASE_URL,
        timeout: 5000
    })
    // 请求拦截
    instance.interceptors.request.use(config => {
      if (projectConfig.is_jwt=="false") {
        return config
      }else{
            let token = localStorage.getItem("_t");
            var dateString = localStorage.getItem("_tt");
            var timeNow = new Date().getTime();

            if (!token || timeNow > dateString) {
              return getToken()
              .then(token => {
                config.headers["Authorization"] = "Bearer " + token
                return config
              })
            } else {
              config.headers["Authorization"] = "Bearer " + token
              return config
            }
      }
    })

    // 响应拦截
    instance.interceptors.response.use(res => res.data)

    return instance(config)
}
